import { useDispatch, useSelector } from 'react-redux';
import Avatar from '../avatar/Avatar';
import Tooltip from '../tooltip/Tooltip';
import snackbarOpen from '../../store/action-creators/snackbarActionCreators';
import { addParticipant, deleteParticipant } from '../../store/actions/conversationActions';
import { ADJUSTER, JOINED_ADJUSTER, NEW, PLUS, REJOINED_ADJUSTER, REJOIN_CHAT, REMOVED_ADJUSTER, REMOVE_FROM_CHAT, SNACKBAR } from '../../utils/constants';
import { isNotEmpty, simpleGTMDataLayer } from '../../utils/utilities';

const existingConversationItems = [REMOVE_FROM_CHAT];
const NotActiveConversationItems = [REJOIN_CHAT]

export default function Participant({ readOnly }: any) {
    const selectedConversation = useSelector((state: any) => state.chat.selectedConversation);
    const user = useSelector((state: any) => state.user)
    const dispatch = useDispatch();
    let isParticipant = (selectedConversation.participants || [])
        .find((p: any) => p.adjusterId === user.email)

    const addAdjuster = (reJoin: boolean) => {
        simpleGTMDataLayer({
            csrId: user.userName,
            event: `Join-The-Chat-Click`,
            event_action: 'Button Click',
            event_category: window.location.pathname,
            event_label: `Joining to the conversation themselves`,
            event_value: `${user.fullName} adding him/her self to the conversation with claim number ${selectedConversation.claimNumber}.`,
            claim_number:selectedConversation.claimNumber
        });
        simpleGTMDataLayer({
            csrId: user.userName,
            event: `Join-The-Chat-Click-Snowplow`,
            event_action: 'Button Click',
            event_category: window.location.pathname + "/Snowplow",
            event_label: `Joining to the conversation themselves`,
            event_value: `${user.fullName} adding him/her self to the conversation with claim number ${selectedConversation.claimNumber}.`,
            claim_number:selectedConversation.claimNumber
        });
        const participant = {
            conversationId: selectedConversation.conversationId,
            claimNumber: selectedConversation.claimNumber,
            participantName: user.fullName,
            adjusterId: user.email,
            participantType: ADJUSTER,
            reJoin: reJoin,
        }
        dispatch(addParticipant(participant, (res: any) => {
            dispatch(snackbarOpen({ type: SNACKBAR.SUCCESS, message: reJoin ? REJOINED_ADJUSTER : JOINED_ADJUSTER, open: true }));
        }))
    }

    const deleteAdjuster = (id: any) => {
        simpleGTMDataLayer({
            csrId: user.userName,
            event: `Remove-From-The-Chat-Click`,
            event_action: 'Button Click',
            event_category: window.location.pathname,
            event_label: `Remove from the conversation themselves`,
            event_value: `${user.fullName} removing him/her self to the conversation with claim number ${selectedConversation.claimNumber}.`
        });
        simpleGTMDataLayer({
            csrId: user.userName,
            event: `Remove-From-The-Chat-Click-Snowplow`,
            event_action: 'Button Click',
            event_category: window.location.pathname + "/Snowplow",
            event_label: `Remove from the conversation themselves`,
            event_value: `${user.fullName} removing him/her self to the conversation with claim number ${selectedConversation.claimNumber}.`
        });
        if (selectedConversation.participants.length < 3) {
            dispatch(snackbarOpen({
                open: true,
                message: "Could not removed, you are the only Adjuster in this Conversation.",
                type: SNACKBAR.ERROR
            }))
            return;
        }
        let participant = {
            adjusterId: user.email,
            conversationId: selectedConversation.conversationId,
            participantId: id
        }
        dispatch(deleteParticipant(participant, (res) => {
            dispatch(snackbarOpen({
                open: true,
                message: REMOVED_ADJUSTER,
                type: SNACKBAR.SUCCESS
            }))
        }))
    }



    return (
        <div style={{ display: "flex" }}>
            {((selectedConversation && selectedConversation.participants) || [])
                .filter((participant: any) => participant.participantType === ADJUSTER)
                .map((participant: any) => {
                    return (
                        <div className='participant-parent'>
                        <Tooltip
                            content={participant.name}
                            key={participant.participantId}
                            className="participant-tooltip"
                        >
                            <Avatar
                            className="participant-avatar"
                                id={participant.participantId}
                                name={participant.name}
                                adjusterId={participant.adjusterId}
                                //style={{ height: 30, width: 30, cursor: "pointer", backgroundColor: !(participant.participantStatus === "active") && "rgba(222, 222, 222, 1)" }}

                                style={{ height: 18, width: 18, padding: 5, borderRadius: 25, cursor: "pointer", backgroundColor: ((participant.name === "QT_USER" )&& (participant.participantStatus === "active")) && "#48C1FF" || !(participant.participantStatus === "active") && "rgba(222, 222, 222, 1)" }}
                                fontSize={10}
                                items={isParticipant && (participant.participantStatus === "active" ? existingConversationItems : NotActiveConversationItems)}
                                deleteParticipant={deleteAdjuster}
                                addAdjuster={addAdjuster}
                            />
                        </Tooltip>
                        </div>
                    );
                })}
            {!isParticipant && !readOnly && isNotEmpty(selectedConversation) && selectedConversation.conversationId !== NEW &&
                <Tooltip content={"Join The Conversation"}>
                    <Avatar
                        symbol={PLUS}
                        style={{ height: 30, width: 30, backgroundColor: "#65A100", cursor: "pointer" }}
                        fontSize={20}
                        marginBottom={4}
                        addAdjuster={addAdjuster}
                    />
                </Tooltip>}

        </div>
    )
}
